import React from "react";
import { Route, Redirect } from "react-router-dom";


if (window.location.search.includes('skill_id')) {
  const token = window.location.search.split('=')[2]
  localStorage.setItem('loginToken', token)
}
const Protected = ({ component: Cmp, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      localStorage.getItem("loginToken") ? <Cmp {...props} /> : (<Redirect to="/login" />)
    }
  />
);

export default Protected;